import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { FirebaseService } from "app/services/firebase.service";
import { FirebaseListObservable, FirebaseObjectObservable } from "angularfire2/database";
import { AngularFireModule } from 'angularfire2';
import { environment } from 'app/../environments/environment';

@Injectable()
export class AdminlistService {
	private db;
	admins: FirebaseListObservable<Adminlist[]>;

	secondApp: firebase.app.App;

	constructor(
		private firebaseSerive: FirebaseService,
	) {
		this.db = firebaseSerive.db;
		this.loadAdminDb();
	}

	loadAdminDb() {
		window.dispatchEvent(new Event('loading'));
		this.admins = this.db.list('/admins') as FirebaseListObservable<Adminlist[]>
		this.admins.subscribe(data => {
			this.triggerDataChange();
		});
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	getAdminslist() {
		return this.admins;
	}

	getAdmin(id: string) {
		return this.db.object('/admins/' + id) as FirebaseObjectObservable<Adminlist>;
	}

	addUser(admin: Adminlist) {
		this.admins.push(admin);
	}

	saveAdmin(admin: Adminlist) {
		if(admin.$key) {
			let user_ref = this.getAdmin(admin.$key);
			delete admin.$key;
			delete admin.password;
			return user_ref.set(admin);
		}
		return false;
	}

	updateAdmin(id: string, data: Adminlist) {
		var admin = this.getAdmin(id);
		data.updated_at = (new Date()).getTime();
		return admin.update(data);
	}

	create_firebaase_user(admin: Adminlist) {
		var self = this;

		if(!self.secondApp) {
			self.secondApp = firebase.initializeApp(environment.firebase, 'Secondary');
		}

		var promise = new Promise((resolve, reject) => {
			self.secondApp.auth().createUserWithEmailAndPassword(admin.email, admin.password).then(new_user => {
				if (new_user) {
					admin.$key = new_user.uid;
					self.saveAdmin(admin);
					resolve(admin);
				}
				else {
					reject('Unknown error');
				}
			self.secondApp.delete();
			self.secondApp = null;
			}).catch(error => {
				reject(error.message);
			self.secondApp.delete();
			self.secondApp = null;
			})
		});

		return promise;
	}

	deleteAdmin(id: string){
		if(!id){
			return new firebase.Promise<void>((resolve, reject) => {
				reject(null);
			})
		}
		var result = this.admins.remove(id);
		this.triggerDataChange();
		return result;
	}
}

export class Adminlist {
  $key?: string;
	uid?: string;
	email?: string = '';
	password?: string = '';
	fullname?: string = '';

	created_at?: number;
	updated_at?: number;

	constructor() {
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/adminlist.service.ts